import { makeStyles, Tab, Tabs, withStyles } from "@material-ui/core";

export const StyledTabs = withStyles((theme) => ({
  root: {
    display: "inline-flex",
    position: "relative",
    "&::after": {
      content: '""',
      position: "absolute",
      display: "block",
      bottom: 0,
      width: "100%",
      borderBottom: theme.custom.border.tab,
      borderRadius: "2px",
      zIndex: -1,
    },
    "& .MuiTabs-indicator": {
      height: "4px",
      borderRadius: "2px",
    },
  },
}))(Tabs);

export const StyledTab = withStyles((theme) => ({
  root: {
    minWidth: "74px",
    position: "relative",
    "& .MuiTab-wrapper": {
      fontWeight: 600,
      color: theme.custom.color.gainsboro,
    },
    "& .MuiTouchRipple-root": {
      display: "none",
    },
    "&.Mui-selected .MuiTab-wrapper": {
      color: theme.custom.color.black,
    },
    "& .MuiTabs-indicator": {
      height: "4px",
      borderRadius: "2px",
    },
  },
}))(Tab);

export const useStyles = makeStyles((theme) => ({
  tabPanel: {
    "& > div": {
      marginTop: theme.spacing(4.5),
    },
  },
  marginBottom: {
    marginBottom: theme.spacing(3),
  },
  select: {
    minWidth: "281px",
    fontFamily: "'Open Sans', sans-serif",
    fontSize: "48px",
    lineHeight: "48px",
    letterSpacing: "0px",
    height: "54px",
    color: theme.custom.color.blackRussian,
  },
  selectIcon: {
    color: theme.custom.color.blackRussian,
    fontSize: "32px",
  },
  versionPrefix: {
    fontWeight: 300,
  },
  versionNumber: {
    fontWeight: 700,
  },
  dateWrapper: {
    display: "flex",
    gap: theme.spacing(2.5),
    marginTop: theme.spacing(4),
    flexWrap: "wrap",
  },
  dateField: {
    width: "190px",
    alignItems: "center",
  },
  dateLabel: {
    fontWeight: 600,
    fontSize: "12px",
    lineHeight: "14px",
    color: theme.custom.color.pewter,
  },
  checkboxWrapper: {
    display: "flex",
    alignItems: "center",
    marginTop: theme.spacing(2.5),
  },
  checkbox: {
    padding: 0,
  },
  checkboxLabel: {
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "22px",
    paddingLeft: "11px",
  },
  listItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: "50px",
    padding: 0,
  },
  listItemText: {
    fontWeight: 700,
    fontSize: "14px",
    lineHeight: "16px",
  },
  button: {
    width: "185px",
    "& .MuiSvgIcon-root": {
      marginRight: theme.spacing(1),
      width: "20px",
      height: "20px",
    },
  },
  title: {
    display: "flex",
    fontWeight: "bold",
    textTransform: "capitalize",
    color: theme.custom.color.black,
    fontSize: "40px",
    letterSpacing: 0,
    lineHeight: "43px",
  },
  toastPosition: {
    "& .MuiSnackbar-root": {
      right: "56px",
      bottom: "36px",
      position: "fixed",
    },
  },
}));
